import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import CustomModal from '../Modal';
import { Button } from '../Button';
import { ModalHeader } from '../ModalHeader';
import styles from './InfoModal.css';

const cx = classnames.bind(styles);

function InfoModal({isOpen, onCloseModal, title, renderButtons, inModal, className, children}) {
    if (!isOpen) {
        return null;
    }

    if (!title) {
        return null;
    }

    return (
        <CustomModal
            isOpen={isOpen}
            onCloseModal={onCloseModal}
            className={cx('modal', className)}
            inModal={inModal}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <p className={styles.title}>
                        {title}
                    </p>
                    <Button
                        iconLeft={{
                            name: 'close'
                        }}
                        type='secondary'
                        onClick={onCloseModal}
                        className={styles.buttonClose}
                        rounded
                    />
                </div>
                <div className={styles.main}>
                    {children}
                </div>
                <div className={styles.footer}>
                    {renderButtons
                        ? renderButtons()
                        : (
                            <Button
                                onClick={onCloseModal}
                                className={styles.button}
                                type='tertiary'
                                label='Close'
                            />
                        )
                    }
                </div>
            </div>
        </CustomModal>
    );
}

InfoModal.defaultProps = {
    title: '',
    renderButtons: null,
    inModal: true
};

InfoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    title: PropTypes.string,
    renderButtons: PropTypes.func,
    children: PropTypes.any.isRequired,
    inModal: PropTypes.bool
};

export {
    InfoModal
};
